import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsSkipPreviousIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M8.12 11.96L19.04 5.16V18.76L8.12 11.96ZM5.1 5.32H6.86V18.6H5.1V5.32ZM11.26 11.96L17.38 15.66V8.24L11.26 11.96Z" />
    </SvgIcon>
  );
});
